import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropdown",
  "use": "dropdown-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 8\" id=\"dropdown\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.586 0c.89 0 1.337 1.077.707 1.707L7.707 7.293a1 1 0 01-1.414 0L.707 1.707C.077 1.077.523 0 1.414 0h11.172z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol